import React, { useState, useEffect } from 'react';
import image from "./img/profile.png";

export default function NavBar() {
    const [showNav, setShowNav] = useState(false);
    const [activeSection, setActiveSection] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const sections = document.querySelectorAll('section');

            let currentActiveSection = null;

            sections.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.clientHeight;

                const isVisible = (scrollPosition + windowHeight * 0.5) >= sectionTop && scrollPosition < (sectionTop + sectionHeight);
                
                if (isVisible) {
                    currentActiveSection = section.id;
                }
            });

            setActiveSection(currentActiveSection);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const handleScrollOut = () => {
            const sections = document.querySelectorAll('section');

            sections.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.clientHeight;

                const isVisible = window.scrollY + window.innerHeight * 0.5 >= sectionTop && window.scrollY < sectionTop + sectionHeight;

                if (!isVisible && activeSection === section.id) {
                    setActiveSection(null);
                }
            });
        };

        window.addEventListener('scroll', handleScrollOut);

        return () => {
            window.removeEventListener('scroll', handleScrollOut);
        };
    }, []);

    const pages = ['About', 'Projects', 'Experience', 'Education', 'Skills'];
    const navLinks = pages.map((page) => {
        return (
            <li className='nav-item' key={page}>
                <a className={`nav-link ${activeSection === page ? 'active' : ''}`} href={'#' + page}>
                    {page}
                </a>
            </li>
        );
    });

    const toggleNav = () => {
        setShowNav(!showNav);
    };

    return (
        <div>
            <nav className="navbar" id="sideNav">
              
              <div className="navbar-brand">
                <a href="#About">
                    <span className='navbar-name'>Andrew Fang</span>
                    <img className="img-profile" src={image} alt="Andrew Fang" />
                </a>
                <button className="toggle-dropdown" onClick={toggleNav}><i className="fa-solid fa-bars"></i></button>
              </div>
              

              <div className={`navbar-collapse ${showNav ? 'show' : ''}`}>
                  <ul className="navbar-nav">
                      {navLinks}
                  </ul>
              </div>
            </nav>
        </div>
    );
}
